import type { UploadedFile } from '~/types/models';

export function isImageUploadedFile(file: UploadedFile | null | undefined): boolean {
    const contentType = String(file?.contentType || '').toLowerCase();
    const fileName = String(file?.fileName || '').toLowerCase();
    return contentType.startsWith('image/')
        || /\.(avif|gif|heic|jpe?g|png|svg|webp)$/.test(fileName);
}
